import ApiBase from '../ApiBase';

class QuizQuestion extends ApiBase {
    route = '/exhibitors/quiz-questions';
}

export default new QuizQuestion();
